import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    formHeader: {
        marginBottom: theme.typography.pxToRem(20)
    }
}));
